export default __webpack_public_path__ + "static/media/ecommerce-lg-3.21306f38.webp";